export default __webpack_public_path__ + "static/media/mandate_confirmed.af0644b4.svg";